import _ from 'lodash';
/*
 * While this feels redundant, it is necessary due to the limitations of sanitizeHtml and really it's usehtmlparser2.
 * sanitizeHtml has an issue with recognizing "<" characters that are directly adjacent to another
 * character as being the opening of a p tag and will automatically try and close it (https://github.com/apostrophecms/sanitize-html/issues/161).
 * Normally this is not an issue as we already encode html entered into our forms within the app use react quill
 * but this does not account for non encoded html coming from POS data.
 */
export function encodeBracketEntities(html: string): string {
  const unencodedMap: Record<string, string> = {};
  let originalUnencodedHtml: string = _.unescape(html);
  // _.unescape doesn't unescape non-breaking spaces so we have to do it ourselves.
  originalUnencodedHtml = originalUnencodedHtml.replace(/&nbsp;/g, ' ');
  const descriptionString: string = originalUnencodedHtml
    .replace(/<\/?p[^>]*>/g, '')
    .replace(/<\/?br>/g, '')
    .replace(/<\/?i[^>]*>/g, '')
    .replace(/<\/?em[^>]*>/g, '')
    .replace(/<\/?strong[^>]*>/g, '')
    .replace(/<a[^>]*>([^<]+)<\/a>/g, '')
    .replace(/<\/?ul[^>]*>/g, '')
    .replace(/<\/?ol[^>]*>/g, '')
    .replace(/<\/?li[^>]*>/g, '');

  const words = descriptionString.split(' ');

  words.forEach((word) => {
    /**
     * Because some html escape characters contain ampersands, if there is an ampersand within the HTML AFTER an escaped character containing an ampersand, the escaped ampersand "&amp" will be
     * added to the first encoded character that contains the ampersand.
     * Ex: <li>test's &</li> has the escape characters "'" = "&#39;" and "&" = "&amp;". When we iterate over the object keys on line 41, the iteration output looks like this:
     * 1st iteration: <li>test&#39; &</li>.
     * 2nd iteration: <li>test&amp;&#39;s &</li>.
     * This is because the "replace" on line 45 replaces the first found ampersand in the string and uses the encoded value, i.e., "test&#39;" becomes "test&amp;#39;".
     * Ampersands (&) get handled properly by sanitizeHtml so we do not need to worry about escaping them.
     */
    const encodedWord: string = word === '&' ? word : _.escape(word);
    if (encodedWord !== word) {
      unencodedMap[word] = encodedWord;
    }
  });

  let encodedHtmlDescription = originalUnencodedHtml;

  Object.keys(unencodedMap).forEach((unencodedString: string) => {
    encodedHtmlDescription = encodedHtmlDescription.replace(unencodedString, unencodedMap[unencodedString]);
  });

  return encodedHtmlDescription;
}
